import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_2.png'
import _imports_1 from '@/assets/pc_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-46513855"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-202024"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center pt-26 pb-22" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "footer_logo",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "link color-white" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "link_middle mt-10 text-center" }
const _hoisted_6 = { class: "text-center mt-10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer_line mc" }, null, -1))
const _hoisted_8 = { class: "text-center footer_title font-blod color-white pt-30" }
const _hoisted_9 = {
  key: 1,
  class: "bg-202024"
}
const _hoisted_10 = { class: "no_rem_pt-40 no_rem_footer mc" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "no_rem_footer_logo",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "flex-row-center-center no_rem_link color-white no_rem_pt-30 no_rem_pb-41" }
const _hoisted_13 = { class: "no_rem_link_middle" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no_rem_footer_line" }, null, -1))
const _hoisted_15 = { class: "flex-row-center-center no_rem_footer_title font-blod color-white no_rem_pt-40" }

import { getCurrentInstance } from 'vue';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'FooterView',
  setup(__props) {

	const { proxy } = getCurrentInstance();
	
	// 跳转备案号
	const toPutOnRecord = () => {
		window.location.href = "https://beian.miit.gov.cn/#/Integrated/index";
	}

return (_ctx: any,_cache: any) => {
  return (_unref(proxy).$store.state.is_phone)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "全国服务热线：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_telephone), 1),
          _createElementVNode("div", _hoisted_5, "联系邮箱：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_email), 1),
          _createElementVNode("div", _hoisted_6, "公司地址：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_address), 1)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_foot_title), 1),
        _createElementVNode("div", {
          class: "text-center record_no color-white mt-16 pb-40",
          onClick: toPutOnRecord
        }, _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_recordNn), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, "全国服务热线：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_telephone), 1),
            _createElementVNode("span", _hoisted_13, "联系邮箱：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_email), 1),
            _createElementVNode("span", null, "公司地址：" + _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_address), 1)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_foot_title), 1),
          _createElementVNode("div", {
            class: "flex-row-center-center color-white no_rem_pt-18 no_rem_pb-41",
            onClick: toPutOnRecord
          }, _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_recordNn), 1)
        ])
      ]))
}
}

})